import $ from 'jquery';
import Component from '../model/Component';
import HttpClient from "../business/HttpClient";
import Utility from "../business/Utility";
import UserManager from '../business/UserManager';
import Tracker from "../business/Tracker";

const forbiddenWords = ["allah", "allupato", "allupata", "allupate", "allupati", "ammucchiata", "ammucchiate", "anal", "anale", "anali", "anoressico", "anoressica", "ano", "ani", "arrapato", "arrapata", "arrapati", "arrapate", "arrusa", "arruso", "assatanato", "asshole", "bagascia", "bagascie", "bagassa", "baggiana", "bagnarsi", "baldracca", "baldracche", "balengo", "balle", "balusa", "batacchio", "battona", "battone", "bastardo", "bastarda", "bastardi", "bastarde", "belino", "belin", "belino", "bega", "bitch", "blow job", "bocchinara", "bocchinare", "bocchinaro", "bocchinari", "bocchino", "bocchini", "bofilo", "boiata", "bordello", "bottana", "brinca", "brucapelo", "bucaiolo", "buco", "buchi", "bullo", "bulla", "bulli", "buliccio", "buona donna", "busone", "cacca", "cacche", "caccone", "caccati in mano e prenditi a schiaffi", "caciocappella", "cadavere", "cagare", "cago", "cagata", "cagate", "cagna", "cazzimma", "cazzino", "cazzo", "cazzola", "cazzone", "cazzoni", "checca", "checche", "chiappa", "chiavo", "chiava", "chiavare", "chiavata", "ciccione", "cicciona", "ciccioni", "ciccione", "ciospo", "ciucciami", "ciuccia", "cock", "coglione", "coglioni", "cogliona", "cornuto", "cornuta", "cornute", "cornuti", "cozza", "cretino", "cretina", "cretini", "cretine", "cristo", "culattina", "culattone", "culattoni", "culo", "culone", "culona", "culi", "di merda", "diavolo", "dildo", "dio", "dirty", "ditalino", "ditalini", "duro", "eiaculazione", "escort", "fanculo", "fascista", "fascisti", "fava", "fica", "fiche", "figa", "figazza", "fighe", "figlio di buona donna", "figlio di puttana", "figone", "finocchio", "fottere", "fottona", "fottersi", "fottiti", "fotto", "fotti", "fracicone", "fregna", "frocio", "froci", "frocione", "froscio", "fuck", "fucker", "fucking", "gesu", "ges", "gnocca", "goldone", "grasso", "grassa", "grassi", "grasse", "grassone", "grassoni", "grilletto", "guanto", "guardone", "ignorante", "ingnoranti", "imbecille", "imbecilli", "immigrati", "immigrato", "incazzarsi", "incazzati", "incazzo", "incoglionirsi", "inculare", "inculo", "incula", "ingoio", "ingoia", "isis", "islam", "islamico", "l'arte bolognese", "leccaculo", "lecchino", "lesbica", "lesbiche", "lecca", "leccamelo", "leccamela", "leccami", "lecco", "leccaciuffo", "limonare", "lofare", "loffa", "loffare", "lumaca", "lurida", "lurido", "madonna", "maiala", "maiale", "maiali", "maialona", "maialoni", "manico", "mannaggia", "maometto", "matello", "merda", "merde", "merda secca", "meretrice", "merdaccia", "merdata", "merdina", "merdone", "merdoso", "mierda", "milf", "milfone", "milfona", "mignotta", "mignotte", "mignottone", "minchia", "minchione", "minnaÊ", "minne", "mona", "monta", "monto", "montare", "mussa", "nave scuola", "nerchia", "negro", "negra", "negri", "negre", "negrone", "negroni", "nuda", "nudi", "nudo", "nude", "olio di palma", "palma", "obesa", "obesi", "obese", "obeso", "orgia", "orgie", "padulo", "palle", "palloso", "passera", "passerina", "patacca", "patata", "patonza", "pecorina", "pedofilo", "pedofilia", "pelosa", "peloso", "pelose", "pelo", "peli", "pene", "peni", "pesce", "picio", "piglianculo", "piglia in culo", "pincare", "pipa", "pipi", "pip“", "pippa", "pippone", "pirla", "pisciare", "piscio", "pisci", "pisello", "piselli", "pistola", "pistolotto", "pomiciare", "pompa", "pompino", "pompinara", "poppe", "porca", "porca madonna", "porca miseria", "porca puttana", "porco", "porcona", "porcone", "porco zio", "potta", "puppami", "puta", "puttana", "puttanone", "puttane", "puttaniere", "preservativo", "profilattico", "profilattici", "preservativi", "prostituta", "prostitute", "quaglia", "randello", "recchione", "ricchione", "ricchioni", "rincoglionire", "rincoglionita", "rincoglionito", "rizzarsi", "rizza", "rizzacazzi", "rompiballe", "rottoinculo", "ruffiano", "rumenta", "salciccia", "satana", "sbattere", "sbattersi", "sbattimi", "sborra", "sboro", "sborare", "sborrata", "sborrone", "sbrodolata", "scopare", "scopiamo", "scopo", "scopi", "scopa", "scopata", "scorreggiare", "scorreggia", "scoreggio", "scorreggione", "scorreggiona", "sega", "seghe", "sesso", "sessuale", "sessuali", "sfigato", "sfigata", "sfigati", "sfigate", "slinguare", "slinguata", "slut", "smandrappata", "soccia", "socmel", "sorca", "sgualdrina", "sgualdrine", "spagnola", "sperma", "spermicida", "spompinare", "spompino", "spompini", "spompina", "sticchio", "stronzi ", "stupido", "stupida", "stupidi", "stupide", "stronza", "stronze", "stronzata", "stronzate", "stronzo", "suca", "succhiami", "succhia", "sveltina", "sverginare", "svergare", "svergo", "tarzanello", "terrone", "terroni", "terrorista", "terroristi", "testa di cazzo", "testicolo", "testicoli", "tetta", "tette", "tettina", "tettine", "tettona", "tettone", "topa", "transessuale", "travone", "troia", "troie", "troione", "troiona", "trombare", "trombo", "tromba", "uccello", "vacca", "vaccaputtana", "vaccatroia", "vacche", "vaffanculo", "vagina", "vagine", "vangare", "verga", "vergine", "vergini", "viadone", "viadoni", "vibratore", "vibratori", "viados", "zinna", "zinne", "zio cantante", "zoccola", "zoccolone", "zoticone"]


class CommentComponent extends Component {

    constructor(element, parentCtrl) {
        super(element, parentCtrl);
        this.init();
    }

    init() {
        this.page = 1;
        this.dataset = this.buildDataset(this.element.dataset);

        this.addCommentButton = $(this.element).find("#sendComment");

        this.addCommentButton.on("click", () => {
            this.addCommentClicked();
        });

        this.loader = $(this.element).find('.loader')[0];
        this.moreBtn = $(this.element).find('.comments-board-more')[0];

        $(this.moreBtn).hide();

        this.moreBtn.addEventListener('click', () => {
            this.page++;
            this.getComments(false).catch(console.error);
        });

        this.commentField = $(this.element).find("[name='comment']");

        this.commentField.on("change paste keyup", (event) => {
            const element = $(event.currentTarget);
            const validity = $(element).val().trim().length > 0;
            this.addCommentButton.toggleClass("disabled", !validity);
        });

        this.commentList = $(this.element).find(".comments");
        this.commentList.html('');

        this.getComments(true).catch(console.error);
    }

    buildDataset(dataset) {
        return {
            key: dataset.key || null,
            pageSize: dataset.pageSize ? parseInt(dataset.pageSize, 10) : 10,
            category: dataset.category || "RECIPE_COMMENTS",
            enablePagination: dataset.enablePagination
                ? dataset.enablePagination
                : true
        };
    }

    async compressAvatar(src, maxBytes = 1024 * 1024) {
        const image = new Image();

        await new Promise((resolve, reject) => {
            image.onload = resolve;
            image.onerror = () => reject(
                new Error("Impossibile caricare l'avatar")
            );
            image.crossOrigin = "anonymous";
            image.src = src;
        });

        let width = image.naturalWidth;
        let height = image.naturalHeight;

        if (!width || !height) {
            throw new Error("Dimensioni avatar non valide");
        }

        const maxDimension = 512;
        const scale = Math.min(
            1,
            maxDimension / Math.max(width, height)
        );

        width = Math.max(1, Math.round(width * scale));
        height = Math.max(1, Math.round(height * scale));

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (!ctx) {
            throw new Error("Canvas non disponibile");
        }

        const qualities = [0.85, 0.70, 0.55, 0.40, 0.25];

        while (true) {
            canvas.width = width;
            canvas.height = height;

            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(image, 0, 0, width, height);

            for (const quality of qualities) {
                const blob = await new Promise((resolve, reject) => {
                    canvas.toBlob(
                        result => result
                            ? resolve(result)
                            : reject(new Error("Compressione fallita")),
                        "image/jpeg",
                        quality
                    );
                });

                const dataUrl = await new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => resolve(reader.result);
                    reader.onerror = () => reject(
                        new Error("Lettura avatar fallita")
                    );

                    reader.readAsDataURL(blob);
                });

                if (
                    typeof dataUrl === "string" &&
                    dataUrl.length < maxBytes
                ) {
                    return dataUrl;
                }
            }

            if (width <= 32 && height <= 32) {
                throw new Error("Impossibile ottenere un avatar sotto 1 MB");
            }

            width = Math.max(1, Math.round(width * 0.7));
            height = Math.max(1, Math.round(height * 0.7));
        }
    }

    getDefaultAvatar() {
        return '<svg><use xlink:href="#svg_circle_profile"/></svg>';
    }

    async getAvatarHtml(src) {
        if (!src) {
            return this.getDefaultAvatar();
        }

        try {
            const compressedSrc = await this.compressAvatar(src);
            return `<img src="${compressedSrc}" class="img" alt="Avatar">`;
        } catch (error) {
            console.warn("Avatar non comprimibile:", error);
            return this.getDefaultAvatar();
        }
    }

    async getLoggedUserAvatarHtml(userId) {
        try {
            const response = await UserManager.getAvatar(userId);
            return await this.getAvatarHtml(response?.body?.path);
        } catch (error) {
            console.warn("Recupero avatar fallito:", error);
            return this.getDefaultAvatar();
        }
    }

    async addCommentClicked() {
        if (this.addCommentButton.hasClass("disabled")) {
            return;
        }

        this.addCommentButton.addClass("disabled");
        this.user = null;

        try {
            this.user = await UserManager.getLoggedUser();
        } catch (error) {
            window.location.href =
                "/login?urlBack=" + Utility.getCurrentUri();
            return;
        }

        try {
            const text = $(this.element).find("#commentText").val();

            if (!this.isValidText(text) || this.isEmpty(text)) {
                const modalTmpl = `
                    <div class="modal-window"
                         component="ModalComponent"
                         data-type="standard"
                         data-show-on-creation="true"
                         data-destroy-on-close="true"
                         data-tmpl-title="Attenzione!"
                         data-tmpl-subtitle="Il tuo commento contiene delle parole vietate.">
                    </div>`;

                $(this.element).append(modalTmpl);
                this.loadChildComponents(this);
                return;
            }

            const avatarHtml = await this.getLoggedUserAvatarHtml(
                this.user.UID
            );

            const data = await HttpClient.doCall({
                method: 'POST',
                url: API_ENDPOINT +
                    `/api/1.0/plugin/comments/${this.dataset.category}/${this.dataset.key}`,
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    text: text,
                    keyDesc: window.location.href
                })
            });

            const commentHtml = `
                <div id="${data.body.id}" class="comment-row">
                    <div class="comment-avatar">
                        ${avatarHtml}
                        <div class="right-text">
                            <p class="user">
                                <a href="/area-riservata">
                                    ${this.user.profile.firstName}
                                </a>
                            </p>
                            <div class="date">
                                <p class="user publish-time">
                                    Meno di un minuto fa
                                </p>
                            </div>
                        </div>
                        <div class="right-text">
                            <p class="waiting-for">In attesa di approvazione</p>
                        </div>
                    </div>
                    <div class="comment-text">
                        <p>${data.body.comment}</p>
                    </div>
                </div>`;

            this.comments = commentHtml + (this.comments || '');
            this.commentList.html(this.comments);

            $(this.element).find("#commentText").val("");

            Tracker.send("EVENT", {
                interactionType: "ZRECIPE_COMMENT",
                productCode: $('#mb-product-externalid').text(),
                name: $('#mb-editorialrecipe-name').text()
            });

            Tracker.send('EVENT', trackingParams);

        } catch (error) {
            console.error("Errore durante l'inserimento del commento:", error);
        } finally {
            this.addCommentButton.removeClass("disabled");
        }
    }

    async getComments(checkForNull) {
        if (this.page === 1) {
            this.comments = '';
        }

        $(this.moreBtn).hide();
        $(this.loader).show();

        try {
            const data = await HttpClient.doCall({
                method: 'GET',
                url: API_ENDPOINT +
                    `/api/1.0/plugin/comments/${this.dataset.category}/${this.dataset.key}/${this.page}/${this.dataset.pageSize}`,
                dataType: "json",
                contentType: "application/json; charset=utf-8"
            });

            const list = data.body?.commentList;

            if (Array.isArray(list) && list.length > 0) {
                const commentHtml = await Promise.all(
                    list.map(async (c) => {
                        let nickname = "Anonimo";
                        let avatarHtml = this.getDefaultAvatar();
                        const userUrl = "javascript:void(0)";

                        if (c.user) {
                            if (c.user.nickname) {
                                nickname = c.user.nickname;
                            }

                            if (c.user.avatar) {
                                avatarHtml = await this.getAvatarHtml(
                                    c.user.avatar
                                );
                            }
                        }

                        return `
                            <div id="${c.id}" class="comment-row">
                                <div class="comment-avatar">
                                    ${avatarHtml}
                                    <div class="right-text">
                                        <p class="user">
                                            <a href="${userUrl}">${nickname}</a>
                                        </p>
                                        <div class="date">
                                            <p class="user publish-time">
                                                ${this.printDate(c.creationDate)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="comment-text">
                                    <p>${c.comment}</p>
                                </div>
                            </div>`;
                    })
                );

                this.comments += commentHtml.join('');
                this.commentList.html(this.comments);

                if (
                    list.length === this.dataset.pageSize &&
                    this.dataset.enablePagination
                ) {
                    $(this.moreBtn).show();
                }
            } else if (checkForNull) {
                this.commentList.html('');
            }

            return this.comments;

        } finally {
            $(this.loader).hide();
        }
    }

    printDate(epocTimeStamp) {
        const date = new Date(epocTimeStamp);

        const monthName = date.toLocaleString("it-IT", {
            month: "long"
        });

        return date.toLocaleString("it-IT", {
                day: "numeric"
            }) + " " + monthName.toUpperCase() + " " +
            date.toLocaleString("it-IT", {
                year: "numeric"
            });
    }

    isEmpty(str) {
        return !str || str.length === 0;
    }

    isValidText(string) {
        if (string && string.length > 1) {
            string = string.trim();
            string = string.replace(/[^\w\s]|_/g, "");
            const split = string.split(" ");

            for (let i = 0; i < split.length; i++) {
                for (let j = 0; j < forbiddenWords.length; j++) {
                    if (split[i].toLowerCase() === forbiddenWords[j]) {
                        return false;
                    }
                }
            }
        }

        return true;
    }
}

export default CommentComponent;
